import React from 'react';

/**
 * A whole-number input that cannot go negative — salaries, probation days, and
 * anything else where a minus sign is meaningless.
 *
 * `min="0"` on its own only governs the spinner buttons and form validation —
 * "-1" can still be typed or pasted straight in — so the minus sign is blocked
 * at the keyboard and any negative value is rejected on the way into state.
 */
const NumberField = ({ value, onChange }) => (
  <input
    type="number"
    className="form-control"
    min="0"
    step="1"
    value={value ?? ''}
    onKeyDown={(e) => {
      if (e.key === '-' || e.key === '+' || e.key === 'e' || e.key === 'E') {
        e.preventDefault();
      }
    }}
    onChange={(e) => {
      const next = e.target.value;
      if (next === '' || Number(next) >= 0) onChange(next);
    }}
  />
);

export default NumberField;
